import COLORS from '../../../utils/constants/colors'

const profileSettingsCloseAccountStyles = {
  cardTitle: {
    marginBottom: 15,
    marginLeft: 10,
    fontWeight: 500,
  },
  subtitle: {
    marginLeft: 10,
    marginBottom: 15,
    color: COLORS.darkGrey,
    lineHeight: '10px',
    // The 10px line height only works on one line; on a phone the text wraps onto the next.
    '@media (max-width: 599px)': {
      lineHeight: 1.4,
    },
  },
  disableWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media (max-width: 599px)': {
      flexWrap: 'wrap',
    },
  },
  disableButtonRoot: {
    marginTop: 15,
  },
}

export default profileSettingsCloseAccountStyles
